export enum RetrievePath {
  RETRIEVE_PROPOSAL = ':externalReference',
}
